import { useState } from "react";
import { Link } from "react-router";
import logoSIA from "@assets/events-awards/logo-sia.png";
import Ad from "@components/Advertisement/Ad";
import { EVENTS_AWARDS_SIA_PATH } from "@events-awards/utils/constants";

import EventsAwardsNavigationMenu from "./EventsAwardsNavigationMenu";
import { siaNavigationMenu } from "./SIAConstants";
import SIASideMenu from "./SIASideMenu";
import ToggleSideMenuButton from "./SIAToggleSideMenu";

/**
 * Events Awards SIA logo menu component
 */
const EventsAwardsSIALogoMenu = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const toggleSideMenu = () => {
    setOpen(!open);
  };

  return (
    <>
      <div
        data-testdata-testid="events-sia-logo-menu-component"
        className="hidden flex-row items-center justify-between lg:flex"
      >
        <Link to={EVENTS_AWARDS_SIA_PATH}>
          <img
            src={logoSIA}
            alt="Sustainability Impact Awards logo"
            width={246}
            height={91}
          />
        </Link>

        <EventsAwardsNavigationMenu
          menuData={siaNavigationMenu}
          className="mt-0 border-none"
        />
      </div>

      <div className="lg:hidden">
        <div className="flex flex items-center justify-between pr-2">
          <Link to={EVENTS_AWARDS_SIA_PATH}>
            <img
              src={logoSIA}
              alt="Sustainability Impact Awards logo"
              width={170}
              height={60}
            />
          </Link>

          <ToggleSideMenuButton onClick={toggleSideMenu} open={open} />
        </div>

        {open ? <SIASideMenu data={siaNavigationMenu} /> : null}
      </div>

      <Ad
        adType="lb2"
        className="mb-5 flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />
    </>
  );
};

export default EventsAwardsSIALogoMenu;
